import { useCallback } from 'react';
import { DrawCanvas } from '../components/DrawCanvas';
import { Toolbar } from '../components/Toolbar';
import { ConfirmDialog } from '../components/ConfirmDialog';
import { playSound } from '../hooks/useSound';
import { useDrawingState } from '../hooks/useDrawingState';

export default function TestApp() {
  const drawing = useDrawingState({
    channelId: 'test-channel',
    userId: 'test-user',
  });

  const handleConfirmTransaction = useCallback(() => {
    console.log(`[TEST] ${drawing.pendingStrokes.length} strokes sent! Total: ${drawing.totalAmount} Bits`);
    drawing.setStrokes(prev => [...prev, ...drawing.allStrokes.filter(s => s.id.startsWith('pending-'))]);
    drawing.setPendingStrokes([]);
    drawing.setTotalAmount(0);
    drawing.setAppState('drawing');
    playSound('./sounds/draw.mp3', 0.4);
  }, [drawing.pendingStrokes.length, drawing.totalAmount, drawing.allStrokes]);

  return (
    <div
      className="overlay-container"
      onMouseEnter={drawing.handleMouseEnter}
      onMouseLeave={drawing.handleMouseLeave}
    >
      <div style={{
        position: 'absolute',
        top: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#ff9500',
        color: 'black',
        padding: '4px 12px',
        borderRadius: 4,
        fontSize: 12,
        fontWeight: 'bold',
        zIndex: 1000,
      }}>
        TEST MODE
      </div>

      <DrawCanvas
        strokes={drawing.allStrokes}
        currentStroke={drawing.currentStroke}
        onStartStroke={drawing.handleStartStroke}
        onContinueStroke={drawing.handleContinueStroke}
        onEndStroke={drawing.handleEndStroke}
        disabled={drawing.appState !== 'drawing'}
        isEraser={drawing.isEraser}
      />

      {drawing.showToolbar && (
        <Toolbar
          color={drawing.color}
          width={drawing.width}
          onColorChange={drawing.setColor}
          onWidthChange={drawing.setWidth}
          disabled={drawing.appState !== 'drawing'}
          isEraser={drawing.isEraser}
          onEraserToggle={drawing.handleEraserToggle}
          onEraserOff={drawing.handleEraserOff}
        />
      )}

      {drawing.showToolbar && drawing.pendingStrokes.length > 0 && drawing.appState === 'drawing' && (
        <div style={{
          position: 'absolute',
          bottom: 80,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 8,
          background: 'rgba(0,0,0,0.8)',
          padding: '12px 16px',
          borderRadius: 8,
          alignItems: 'center',
        }}>
          <span style={{ color: 'white', fontSize: 14 }}>
            {drawing.pendingAmount} Bits
          </span>
          <button
            onClick={drawing.handleClearPending}
            style={{
              padding: '6px 12px',
              border: 'none',
              borderRadius: 4,
              background: '#555',
              color: 'white',
              fontSize: 12,
              cursor: 'pointer',
            }}
          >
            Clear
          </button>
          <button
            onClick={drawing.handleSubmit}
            style={{
              padding: '6px 16px',
              border: 'none',
              borderRadius: 4,
              background: '#9147ff',
              color: 'white',
              fontSize: 14,
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            Send
          </button>
        </div>
      )}

      {drawing.appState === 'confirming' && (
        <ConfirmDialog
          bits={drawing.totalAmount}
          onConfirm={handleConfirmTransaction}
          onCancel={drawing.handleCancelTransaction}
        />
      )}
    </div>
  );
}
